import { render, staticRenderFns } from "./SuperCollectionPage.vue?vue&type=template&id=2c9e9a35&scoped=true&"
import script from "./SuperCollectionPage.vue?vue&type=script&lang=js&"
export * from "./SuperCollectionPage.vue?vue&type=script&lang=js&"
import style0 from "./SuperCollectionPage.vue?vue&type=style&index=0&id=2c9e9a35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e9a35",
  null
  
)

export default component.exports